module.exports = __webpack_public_path__ + "img/law_books.b03f62be.jpeg";